
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



  const cardData =
  {
    keyword: 'Swift Dzire On Rent in Pune',
    heading: 'AB Ghule Cabs: Swift Dzire On Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers the Swift Dzire on rent in Pune, providing a perfect combination of comfort, affordability, and style. Ideal for both business and leisure trips, our well-maintained Swift Dzire cars ensure a smooth and pleasant ride. Whether you need a ride for a special occasion, daily commutes, or long-distance travel, our Swift Dzire on rent offers an excellent travel experience with competitive pricing and exceptional customer service.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Swift Dzire On Rent in Pune',

   "topPlaces": [
  {
    title: "Comfortable and Spacious Interiors",
    description: "The Swift Dzire is designed with spacious interiors, making it an ideal choice for families, small groups, or business trips. The comfortable seating ensures that your journey, whether short or long, is relaxing and enjoyable."
  },
  {
    title: "Fuel-Efficient and Cost-Effective",
    description: "The Swift Dzire is known for its fuel efficiency, making it a great option for long-distance travel. Its excellent mileage helps save on fuel costs, providing an affordable and cost-effective solution for your travel needs."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "At AB Ghule Cabs, we offer the Swift Dzire at competitive prices with no hidden charges. Our pricing is transparent, so you know exactly what you're paying for, ensuring no surprises at the time of billing."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All our Swift Dzire vehicles are regularly serviced and maintained to meet high safety standards. We ensure that the car is in excellent condition for a safe and comfortable ride."
  },
  {
    title: "Experienced and Professional Drivers",
    description: "Our drivers are professional, courteous, and well-versed in navigating Pune and its surrounding areas. They prioritize your safety and comfort while ensuring you reach your destination on time."
  },
  {
    title: "Ideal for Short and Long-Distance Travel",
    description: "Whether you need a ride within Pune or are planning a road trip to nearby cities, the Swift Dzire offers a comfortable and reliable solution for both short and long-distance travel."
  },
  {
    title: "Modern Features",
    description: "The Swift Dzire is equipped with modern features like air conditioning, power steering, Bluetooth connectivity, and an infotainment system, making your travel more enjoyable and convenient."
  },
  {
    title: "Flexible Rental Options",
    description: "We provide flexible rental packages for daily, weekly, and long-term rentals, ensuring that you can choose a rental period that fits your needs. Whether it’s a few hours or several days, AB Ghule Cabs has you covered."
  },
  {
    title: "24/7 Availability",
    description: "AB Ghule Cabs offers 24/7 availability, so whether it’s an early morning airport pickup or a late-night drop, you can rely on us to provide the Swift Dzire at any time of day or night."
  },
  {
    title: "Easy Booking Process",
    description: "Booking your Swift Dzire is quick and easy. You can book online or by phone, making it simple to secure your ride in advance and ensure a smooth travel experience."
  }
],


services: [
    {
      "name": "Swift Dzire Per Km Rate in Pune",
      description: "Looking for Swift Dzire rental services in Pune? AB Ghule Cabs offers competitive per km rates for Swift Dzire rentals, ensuring affordable and reliable travel for both local and outstation trips. Our rates are transparent with no hidden charges."
    },
    {
      "name": "Swift Dzire Rent Per Km Rate Per Day",
      description: "Rent a Swift Dzire in Pune for the entire day at affordable rates. AB Ghule Cabs offers a flexible per-day rent for Swift Dzire cars, allowing you to travel in comfort and style without worrying about the distance."
    },
    {
      "name": "Swift Dzire Per Km Rate in Pune",
      description: "AB Ghule Cabs provides the best per km rates for Swift Dzire rentals in Pune. Whether you need the car for local trips or outstation travel, our Swift Dzire rental rates are designed to suit your budget and ensure a pleasant journey."
    },
    {
      "name": "Swift Dzire Per Km Rate in Pimpri Chinchwad",
      description: "Looking for Swift Dzire rentals in Pimpri Chinchwad? AB Ghule Cabs offers the best per km rates for Swift Dzire cars in the Pimpri Chinchwad area, with options for both local and outstation travel."
    },
    {
      "name": "Swift Dzire Tour Service Cost",
      description: "AB Ghule Cabs provides affordable Swift Dzire tour services at competitive rates. Whether you're planning a day trip or a multi-day tour, our Swift Dzire rentals offer comfort and style, with transparent pricing and no hidden fees."
    },
    {
      "name": "Pune to Mahabaleshwar Swift Dzire Tour",
      description: "Travel from Pune to Mahabaleshwar in style with our Swift Dzire rental services. Our affordable rates and professional drivers ensure a smooth and comfortable journey to this scenic hill station."
    },
    {
      "name": "Pune to Shirdi Swift Dzire Tour",
      description: "Book a Swift Dzire for your trip to Shirdi with AB Ghule Cabs. Our well-maintained vehicles and experienced drivers ensure a safe and comfortable ride to this spiritual destination."
    },
    {
      "name": "Pune Airport to Shirdi Tour Packages",
      description: "AB Ghule Cabs offers custom tour packages for your journey from Pune Airport to Shirdi. Our Swift Dzire rental services are available with competitive pricing for a smooth and stress-free ride."
    },
    {
      "name": "Pune to Nashik Swift Dzire on Rent",
      description: "Planning a trip from Pune to Nashik? Rent a Swift Dzire with AB Ghule Cabs for a comfortable and efficient ride. Our competitive rental rates make this journey convenient and affordable."
    },
    {
      "name": "Pune to Lonavala Swift Dzire on Rent",
      description: "Book a Swift Dzire for your trip from Pune to Lonavala with AB Ghule Cabs. Our cars are ideal for this popular destination, providing comfort and convenience for a seamless travel experience."
    },
    {
      "name": "Pune to Ashtavinayak Darshan Swift Dzire on Rent",
      description: "AB Ghule Cabs offers Swift Dzire rentals for your Ashtavinayak Darshan trip. Whether it's a one-day or extended journey, our vehicles ensure a smooth and comfortable ride to all the sacred temples."
    },
    {
      "name": "Pune to Panchgani Swift Dzire on Rent",
      description: "Rent a Swift Dzire for your trip from Pune to Panchgani with AB Ghule Cabs. Enjoy a relaxing ride to this beautiful hill station in our well-maintained and comfortable Swift Dzire vehicles."
    },
    {
      "name": "Pune to Lavasa Swift Dzire on Rent",
      description: "Book a Swift Dzire for your journey to Lavasa from Pune with AB Ghule Cabs. Our competitive rental rates and comfortable ride options make it easy to visit Lavasa for a day trip or extended stay."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent",
      description: "AB Ghule Cabs offers Swift Dzire rentals for your journey to the 5 Jyotirlinga temples. Enjoy a peaceful and convenient ride with our professional drivers, ensuring a comfortable and spiritual experience."
    },
    {
      "name": "Pune Darshan Swift Dzire On Rent",
      description: "Experience a city tour in Pune in the comfort of a Swift Dzire with AB Ghule Cabs. Our local tour services ensure a smooth and efficient trip to all the must-visit spots in Pune, with a professional driver at your service."
    },
    {
      "name": "Swift Dzire Rent Near Me",
      description: "Find Swift Dzire rentals near you in Pune with AB Ghule Cabs. Our fleet of well-maintained Swift Dzire cars are available for local and outstation bookings, ensuring you travel comfortably wherever you need to go."
    },
    {
      "name": "Swift Dzire Online Booking",
      description: "Book a Swift Dzire online with AB Ghule Cabs for a hassle-free experience. Our easy online booking system lets you reserve a Swift Dzire for local, outstation, and airport trips in just a few clicks."
    },
    {
      "name": "Swift Dzire On Rent In Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Swift Dzire On Rent In Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Swift Dzire Per Km Rate Pune", "- Swift Dzire Rent Per Km Rate Per Day"],
    ["Swift Dzire Per Km Rate in Pune", "- Swift Dzire Per Km Rate in Pune"],
    ["Swift Dzire Per Km Rate Pimpri Chinchwad", "- Swift Dzire Tour Service Cost"],
    ["Pune to Mahabaleshwar Swift Dzire Tour", "- Pune to Shirdi Swift Dzire Tour"],
    ["Pune Airport to Shirdi Tour Packages", "- Pune to Nashik Swift Dzire on Rent"],
    ["Pune to Lonavala Swift Dzire on Rent", "- Pune to Ashtavinayak Darshan Swift Dzire on Rent"],
    ["Pune to Panchgani Swift Dzire on Rent", "- Pune to Lavasa Swift Dzire on Rent"],
    ["Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent", "- Pune Darshan Swift Dzire on Rent"],
    ["Swift Dzire Rent Near Me", "- Swift Dzire Online Booking"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Affordable and Comfortable Ride",
      WhyChoosedescription: "The Swift Dzire is an excellent choice for those seeking an affordable yet comfortable ride. With its spacious interior, smooth drive, and efficient fuel economy, it’s perfect for both short trips and longer journeys around Pune."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our Swift Dzire cars are regularly serviced and maintained to ensure they are in excellent condition. Clean, sanitized, and ready for your ride, we ensure that every journey is smooth and comfortable."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Safety and professionalism are our top priorities. Our drivers are well-trained, experienced, and background-checked to guarantee a safe and comfortable journey. They are well-versed with the local routes to ensure timely arrivals."
    },
    {
      WhyChooseheading: "Affordable Rental Options",
      WhyChoosedescription: "We offer competitive pricing for renting a Swift Dzire in Pune. Whether you need the car for a few hours, a day, or a week, our rental options are affordable and designed to meet different travel needs."
    },
    {
      WhyChooseheading: "Perfect for Business and Leisure",
      WhyChoosedescription: "The Swift Dzire is ideal for both business and leisure travel. Its modern features and comfortable seating make it a great choice for business meetings, sightseeing trips, or family getaways in and around Pune."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "We provide flexible rental packages to cater to your specific needs. Whether you need the car for local travel, outstation trips, or airport transfers, we have the right solution for you."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a Swift Dzire is simple. You can book online via our website or mobile app, or by calling our customer service team. We aim to make your booking experience as smooth and convenient as possible."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available round the clock to meet your travel needs. Whether it's a last-minute booking or an early morning ride, our customer service team is ready to assist you at any time."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I rent a Swift Dzire in Pune?',
      answer: 'You can rent a Swift Dzire through our website, mobile app, or by calling our customer service team. The booking process is quick and simple.',
    },
    {
      id: 'FAQ2',
      question: 'What is the seating capacity of the Swift Dzire?',
      answer: 'The Swift Dzire comfortably seats 4 passengers, making it an ideal choice for small groups or family trips.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Swift Dzire air-conditioned?',
      answer: 'Yes, all our Swift Dzire cars are fully air-conditioned to ensure a comfortable ride, regardless of the weather.',
    },
    {
      id: 'FAQ4',
      question: 'What is the cost of renting a Swift Dzire?',
      answer: 'The cost depends on the rental duration and distance. We offer competitive and transparent pricing with no hidden charges. You will receive an upfront quote when booking.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers professional and experienced?',
      answer: 'Yes, all our drivers are professionally trained, experienced, and background-checked. They ensure that you have a safe, smooth, and pleasant ride.',
    },
    {
      id: 'FAQ6',
      question: 'Can I use the Swift Dzire for outstation trips?',
      answer: 'Yes, the Swift Dzire is perfect for outstation travel. We offer customized packages for long-distance travel, making it ideal for trips beyond Pune.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for my Swift Dzire rental?',
      answer: 'We offer multiple payment options, including cash, credit/debit card, and online payment via our mobile app.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. For assistance, you can also contact our customer service team.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours. We provide a clear breakdown of any extra charges before confirming your booking.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other car rental services?',
      answer: 'AB Ghule Cabs stands out for our commitment to customer satisfaction, affordable pricing, well-maintained vehicles like the Swift Dzire, professional drivers, and transparent service. We offer a personalized and reliable travel experience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Ravi Desai',
      feedback: 'I rented the Swift Dzire for a business trip in Pune, and I was very pleased with the service. The car was clean, comfortable, and the driver was very professional. The whole experience was seamless, and I’ll definitely use AB Ghule Cabs again!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Patil',
      feedback: 'I booked the Swift Dzire for a family trip to nearby places, and it was a great choice. The car was spacious and very comfortable. The driver was courteous, and the booking process was easy. Highly recommend AB Ghule Cabs for anyone looking for reliable and affordable car rentals!',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>

<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Swift Dzire on Rent in Pune | Sedan Car Hire & Rental</title>
  <meta name="description" content="Swift Dzire on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Nashik, and more." />
  <meta name="keywords" content="swift dzire per km rate pune, swift dzire rent per km rate per day, swift dzire per km rate in Pune, swift dzire per km rate in pune, swift dzire per km rate pimpri chinchwad, swift dzire tour service cost, pune to mahabaleshwar swift dzire tour, pune to shirdi swift dzire tour, pune airport to shirdi tour packages, pune to nashik swift dzire on rent, pune to lonavala swift dzire on rent, pune to ashtavinayak darshan swift dzire on rent, pune to panchgani Swift dzire on Rent, pune to lavasa swift dzire on rent, pune to 5 jyotirlinga darshan swift dzire on Rent, pune darshan Swift Dzire On Rent, swift dzire rent near me, swift dzire online booking" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Swift Dzire on Rent in Pune | Sedan Car Hire & Rental" />
  <meta property="og:description" content="Swift Dzire on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Nashik, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/swift-dzire-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/swift-dzire-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Swift Dzire on Rent in Pune",
        description: "Swift Dzire on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Nashik, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/swift-dzire-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/swift-dzire-rent.jpg",
        "image": "https://abghulecabs.com/images/swift-dzire-rent.jpg",
        "priceRange": "₹1500 - ₹3000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/swift-dzire-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas J"
            },
            "datePublished": "2024-11-12",
            "reviewBody": "Rented Swift Dzire for a trip to Nashik. Very comfortable and reliable service. Highly recommend AB Ghule Cabs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha K"
            },
            "datePublished": "2024-10-28",
            "reviewBody": "Great experience with AB Ghule Cabs. The Swift Dzire was clean, well-maintained, and provided a smooth ride to Lonavala."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Swift Dzire Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/swift-dzire-on-rent-in-pune"
        },
        "keywords": "swift dzire per km rate pune, swift dzire rent per km rate per day, swift dzire per km rate in Pune, swift dzire per km rate in pune, swift dzire per km rate pimpri chinchwad, swift dzire tour service cost, pune to mahabaleshwar swift dzire tour, pune to shirdi swift dzire tour, pune airport to shirdi tour packages, pune to nashik swift dzire on rent, pune to lonavala swift dzire on rent, pune to ashtavinayak darshan swift dzire on rent, pune to panchgani Swift dzire on Rent, pune to lavasa swift dzire on rent, pune to 5 jyotirlinga darshan swift dzire on Rent, pune darshan Swift Dzire On Rent, swift dzire rent near me, swift dzire online booking"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/43.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Swiftdzireonrentinpune;